import type { SvgIconProps } from '../../types/props.ts'

export const CtvIcon = (props: SvgIconProps) => {
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      fill="none"
      aria-hidden="true"
      role="img"
    >
      <g filter="url(#filter0_d_18394_198025)">
        <path
          d="M2.54688 7.99252C2.54688 4.68294 5.44396 2 9.0177 2H43.5287C47.1025 2 49.9996 4.68294 49.9996 7.99252V44.0075C49.9996 47.3171 47.1025 50 43.5287 50H9.0177C5.44396 50 2.54688 47.3171 2.54688 44.0075V7.99252Z"
          fill="#F6F6F6"
        />
      </g>
      <path
        d="M14.9576 42.2065V39.1505C14.9576 38.3985 14.5262 37.7165 13.6958 37.7165C12.8653 37.7165 12.3865 38.3985 12.3865 39.1505V42.2065H10.8594V36.4885H12.27L12.3822 37.1845C12.7057 36.6045 13.4175 36.3965 14.0042 36.3965C14.7397 36.3965 15.4774 36.6745 15.8268 37.4605C16.2444 36.779 17.0427 36.3759 17.8867 36.4205C19.6338 36.4205 20.4944 37.4205 20.4944 39.1285V42.2065H18.9716V39.1285C18.9716 38.3765 18.6351 37.7285 17.8112 37.7285C16.9872 37.7285 16.476 38.3885 16.476 39.1405V42.1965L14.9576 42.2065Z"
        fill="#383838"
      />
      <path
        d="M26.8514 42.2062V39.2182C26.8514 38.3502 26.3402 37.6902 25.3674 37.6902C24.4313 37.6902 23.795 38.4202 23.795 39.2902V42.2062H22.2852V36.4882H23.6462L23.7454 37.2642C24.3709 36.6982 24.9943 36.4082 25.7686 36.4082C27.2159 36.4082 28.3764 37.4082 28.3764 39.2082V42.2082L26.8514 42.2062Z"
        fill="#383838"
      />
      <path
        d="M32.1931 34.8916V36.5116H33.8906V37.7276H32.1802V40.1916C32.1802 40.7356 32.5059 40.9916 32.9804 40.9916C33.2364 40.9846 33.4876 40.9252 33.7159 40.8176L34.1473 42.0176C33.7472 42.1723 33.319 42.2551 32.8855 42.2616C31.5503 42.3076 30.6768 41.6016 30.6768 40.1776V37.7276H29.5293V36.5116H30.6768V35.0416L32.1931 34.8916Z"
        fill="#383838"
      />
      <path
        d="M40.1934 42.2062V39.2182C40.1934 38.3502 39.68 37.6902 38.7073 37.6902C37.7712 37.6902 37.1349 38.4202 37.1349 39.2902V42.2062H35.625V36.4882H36.9839L37.0852 37.2642C37.7086 36.6982 38.332 36.4082 39.1063 36.4082C40.5536 36.4082 41.7162 37.4082 41.7162 39.2082V42.2082L40.1934 42.2062Z"
        fill="#383838"
      />
      <path
        d="M25.9565 21.687C25.9505 21.6807 25.9461 21.6732 25.9436 21.6651C25.7336 21.2976 25.4908 20.9463 25.2781 20.5799L18.8897 10.3071C18.8471 10.2328 18.7918 10.1654 18.726 10.1076C18.451 9.85149 18.0706 9.71709 17.6813 9.73856H12.4625C12.0417 9.73856 11.6381 9.89351 11.3408 10.1693C11.0434 10.445 10.8766 10.819 10.8772 11.2087V32.7837C10.8659 33.3358 11.2306 33.8349 11.7883 34.0304C12.283 34.1888 12.832 34.0728 13.2034 33.7312L17.8838 29.3947C18.3045 29.0076 18.9449 28.9121 19.4755 29.1573L25.291 31.8542C25.8722 32.1229 26.5771 31.98 26.9839 31.5111L29.9369 28.0901L25.9565 21.687Z"
        fill="#1AC9AA"
      />
      <path
        d="M34.8841 9.71397C34.3228 9.71305 33.8044 9.99198 33.5272 10.444C31.6339 13.51 28.5905 18.6663 26.6348 21.6265C26.5656 21.7382 26.4405 21.8103 26.3017 21.8184C26.163 21.8264 26.0291 21.7693 25.9455 21.6664H25.9434L29.9367 28.0895L33.0253 24.471C33.2685 24.1903 33.629 24.0187 34.017 23.9989C34.4049 23.9791 34.7836 24.113 35.0586 24.3673L39.334 28.3268C39.5298 28.5148 39.7819 28.644 40.0578 28.6978C40.4581 28.7727 40.8736 28.677 41.1895 28.4374C41.5055 28.1977 41.6886 27.8393 41.6882 27.4611V11.1681C41.6882 10.7821 41.5225 10.4119 41.2276 10.1392C40.9327 9.86642 40.5327 9.71345 40.1159 9.71397H34.8841Z"
        fill="url(#paint0_linear_18394_198025)"
      />
      <path
        d="M25.9434 21.665C25.9458 21.6732 25.9502 21.6807 25.9563 21.687L29.9431 28.0901L25.9563 21.687L25.9434 21.665Z"
        fill="#1AC9AA"
      />
      <path
        d="M25.9434 21.665C25.9458 21.6732 25.9502 21.6807 25.9563 21.687L29.9431 28.0901L25.9563 21.687L25.9434 21.665Z"
        fill="url(#paint1_linear_18394_198025)"
      />
      <defs>
        <filter
          id="filter0_d_18394_198025"
          x="0.546875"
          y="0"
          width="55.4531"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18394_198025"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18394_198025"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_18394_198025"
          x1="29.163"
          y1="33.2143"
          x2="45.6339"
          y2="28.7516"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#045562" />
          <stop offset="0.03" stopColor="#05606F" />
          <stop offset="0.1" stopColor="#06778A" />
          <stop offset="0.18" stopColor="#088BA0" />
          <stop offset="0.27" stopColor="#0999B1" />
          <stop offset="0.39" stopColor="#09A3BC" />
          <stop offset="0.55" stopColor="#0AA9C3" />
          <stop offset="1" stopColor="#0AABC5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18394_198025"
          x1="29.2377"
          y1="37.9677"
          x2="45.7844"
          y2="35.4349"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#045562" />
          <stop offset="0.03" stopColor="#05606F" />
          <stop offset="0.1" stopColor="#06778A" />
          <stop offset="0.18" stopColor="#088BA0" />
          <stop offset="0.27" stopColor="#0999B1" />
          <stop offset="0.39" stopColor="#09A3BC" />
          <stop offset="0.55" stopColor="#0AA9C3" />
          <stop offset="1" stopColor="#0AABC5" />
        </linearGradient>
      </defs>
    </svg>
  )
}
